<template>
  <div id="editNewSurvey">
    <topBar
      :title="$t('newSurvey.title')"
    />
    <div class="commonContainer">
      <div class="editContainer">
        <el-card class="box-card">
          <div class="editBox">
            <div class="orangeIcon">
              <i class="el-icon-edit"></i>
            </div>
            <div class="editContent">

              <el-tabs v-model="activeName" align-center style="margin: 40px 0 30px 0" type="card">
                <el-tab-pane label="设置问卷" name="first">
                </el-tab-pane>
                <el-tab-pane label="设置题目" name="second">
                </el-tab-pane>
              </el-tabs>

              <template v-if="activeName === 'first' ">
                <el-form ref="form" :model="form" label-width="200px">
                  <el-form-item :label="$t('newSurvey.surveyName')" required>
                    <el-input v-model="form.name" maxlength="250"></el-input>
                  </el-form-item>
                  <!--<anyImageUpload
                    :label="$t('survey.pic') + '(750*1642)'
                    v-model="form.image"
                    labelWidth="200"
                    :type="0"
                  />-->
                  <el-form-item :label="$t('newSurvey.description')">
                    <el-input v-model="form.description" type="textarea" maxlength="250"></el-input>
                  </el-form-item>

                  <file-upload
                    v-model="form.attachment"
                    label="适用门店"
                    labelWidth="200"
                  />

                  <!-- 适用门店 暂时不要
                  <matchDoor
                    v-model="doorInfos"
                  />-->
                  <el-form-item label="显示序号">
                    <el-switch v-model="form.showSerialNum"></el-switch>
                  </el-form-item>

                  <multiPicker
                    :label="$t('newSurvey.accessRole')"
                    v-model="accessRoles"
                    :options="tagOptions"
                    labelWidth="200"
                  />

                  <anyImageUpload
                    label="封面设置"
                    v-model="form.startImage"
                    labelWidth="200"
                    :type="0"
                    text="建议尺寸9:16"
                  />

                  <anyImageUpload
                    label="封底设置"
                    v-model="form.endImage"
                    labelWidth="200"
                    :type="0"
                    text="建议尺寸9:16"
                  />

                  <anyImageUpload
                    label="背景设置"
                    v-model="form.coverImage"
                    labelWidth="200"
                    :type="0"
                    text="建议尺寸9:16"
                  />

                  <anyImageUpload
                    label="二维码海报"
                    v-model="form.qrcodeBgImage"
                    labelWidth="200"
                    :type="0"
                    text="建议尺寸9:16"
                  />

                </el-form>
              </template>

              <template v-if="activeName === 'second'">
                <div class="customFormItem">
                  <span class="label">问卷题目</span>
                  <div class="formItemContent">
                    <el-card class="box-card questionsContainer" v-if="questions.length">
                      <ul class="questionBox">
                        <li v-for="(question, i) in questions" :key="i">
                          <el-row type="flex" :gutter="20">
                            <el-col :span="3">
                              <el-input v-model="question.sort" :placeholder="i + 1" @change="changeSort(question.sort, i)"></el-input>
                            </el-col>
                            <el-col :span="18" >
                              <span v-if="question.necessary" style="color: red">*</span>
                              <span class="name">{{ question.name.zh_CN }} ({{computeType(question.type)}})</span>
                              <br />
                              <div v-html="question.detail"></div>
                            </el-col>
                            <el-col :span="3">
                              <i class="el-icon-edit" @click="onEditQuestion(i)" style="margin-right: 10px"></i>
                              <i class="el-icon-delete" @click="onDeleteQuestion(i)"></i>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="20" :offset="3">
                              <div class="options">
                                <div class="option" :key="j" v-for="(item, j) in question.items">({{ j + 1}}) {{ item.content.zh_CN }}</div>
                              </div>
                            </el-col>
                          </el-row>
                        </li>
                      </ul>
                    </el-card>
                    <div class="input-box">
                      <el-button type="text" icon="el-icon-circle-plus-outline" size="medium" @click="addQuestion">添加题目</el-button>
                    </div>
                  </div>
                </div>
              </template>


            </div>

            <footer v-if="!this.id && this.activeName === 'first' ">
              <el-button type="success" @click="next('second')" >下一步, 添加题目</el-button>
              <el-button type="primary" @click="onClose">{{ $t('close') }}</el-button>
            </footer>

            <footer v-if="!this.id && this.activeName === 'second' ">
              <el-button type="success" @click="next('first')" >上一步, 设置问卷</el-button>
              <el-button type="primary" @click="onSave">{{ $t('save') }}</el-button>
              <el-button type="primary" @click="onClose">{{ $t('close') }}</el-button>
            </footer>

          </div>
        </el-card>
      </div>
    </div>
    <el-dialog
      :title="operation + $t('newSurvey.question')"
      :visible.sync="questionsDialog"
      width="70%"
      center
    >
      <div style="margin: 10px 0 20px">
        <el-form :model="editQuestion" ref="editQuestion" label-width="100px">
          <multiLangInput
            label="题目名称"
            labelWidth="100"
            :required="true"
            v-model="editQuestion.name"
          />

          <el-form-item label="题干:" prop="detail">
            <div ref="editor" id="editorDiv"></div>
          </el-form-item>

          <!--<multiLangInput
            label="题干"
            labelWidth="100"
            v-model="editQuestion.detail"
          />-->

          <el-form-item label="是否必答" >
            <el-switch v-model="editQuestion.necessary"></el-switch>
          </el-form-item>

          <el-form-item label="至少选择几项" v-show="editQuestion.type == 2">
            <el-input-number v-model="editQuestion.optionMin"></el-input-number>
          </el-form-item>

          <el-form-item label="最多选择几项" v-show="editQuestion.type == 2">
            <el-input-number v-model="editQuestion.optionMax"></el-input-number>
          </el-form-item>

          <div v-on:mouseup="changeType($event, editQuestion.type)">
            <el-form-item label="题目类型" >
              <el-radio-group v-model="editQuestion.type">
                <el-radio label="1" border>单选题</el-radio>
                <el-radio label="2" border>多选题</el-radio>
                <el-radio label="3" border>NPS量表题</el-radio>
                <el-radio label="4" border>填空题</el-radio>
                <!--<el-radio label="5" border>文本说明</el-radio>-->
                <!--<el-radio label="5" border>图片/视频</el-radio>-->
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="customFormItem customFormItemInner" v-show="editQuestion.type == 1 || editQuestion.type == 2">
            <span class="label">题目选项</span>
            <div class="formItemContent">
              <el-card class="box-card questionOptionsContainer" v-if="editQuestion.items && editQuestion.items.length">
                <ul class="optionsBox">
                  <li v-for="(opt, i) in editQuestion.items" :key="i">
                    <el-row type="flex" :gutter="20">
                      <el-col :span="1">
                        <span>{{ i + 1 }}. </span>
                      </el-col>
                      <el-col :span="22">
                        <multiInput
                          v-if="!opt.isInput"
                          v-model="editQuestion.items[i].content"
                        />
                        <span v-if="opt.isInput">{{ $t('newSurvey.other') }}___________</span>
                        <el-row type="flex" v-if="opt.isInput">
                          <el-form :inline="true">
                            <el-form-item label="是否必填" style="margin-bottom: 0">
                              <el-switch v-model="opt.necessary"></el-switch>
                            </el-form-item>
                          </el-form>
                        </el-row>
<!--                        <el-row type="flex">
                          <el-form :inline="true">
                            <el-form-item label="是否输入项">
                              <el-switch v-model="opt.isInput"></el-switch>
                            </el-form-item>
                            <el-form-item label="是否必填" style="margin-left: 40px">
                              <el-switch v-model="opt.necessary"></el-switch>
                            </el-form-item>
                          </el-form>
                        </el-row>-->
                      </el-col>
                      <el-col :span="1">
                        <i class="el-icon-delete" @click="onDeleteItem(i)"></i>
                      </el-col>
                    </el-row>
                  </li>
                </ul>
              </el-card>
              <div class="input-box">
                <el-button type="text" icon="el-icon-circle-plus-outline" size="medium" @click="addOption">添加选择项</el-button>
                <el-button type="text" icon="el-icon-circle-plus-outline" size="medium" @click="addOtherOption">添加其他项</el-button>
              </div>
            </div>
          </div>

          <el-form-item label="量表维度" v-show="editQuestion.type == 3">
            <el-input-number v-model="editQuestion.maxScore" :min="1" :max="10"></el-input-number>
          </el-form-item>

          <div class="scoreText" v-show="editQuestion.type == 3">
            <ul>
              <li v-for="count in editQuestion.maxScore" :key="count"></li>
            </ul>
            <div class="scoreTextInput">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="6"><el-input v-model="editQuestion.leftLabel" placeholder="最低分文案" class="textInput"></el-input></el-col>
                <el-col :span="6"><el-input v-model="editQuestion.rightLabel" placeholder="最高分文案" class="textInput"></el-input></el-col>
              </el-row>
            </div>

          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="questionsDialog = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="confirmQuestion">{{ $t('confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TopBar from '../components/TopBar.vue'
import _ from 'lodash'
import anyImageUpload from '../components/anyImageUpload.vue'
import matchDoor from '../components/matchDoor.vue'
import multiPicker from '../components/multiPicker.vue'
import multiLangInput from '../components/multiLangInput'
import multiInput from '../components/multiInput'
import fileUpload from '../components/fileUpload'
import Editor from 'wangeditor'

const multiInputDefault = {
  'zh_HK': '',
  'zh_CN': '',
  'en': ''
}

export default {
  name: 'EditNewSurvey',
  components: {
    topBar: TopBar,
    anyImageUpload,
    matchDoor,
    multiPicker,
    multiLangInput,
    multiInput,
    fileUpload
  },
  data: function () {
    return {
      id: this.$route.query.id,
      activeName: 'first',
      initForm: {
        name: '', // 问卷名称
        description: '', // 问卷描述
        showSerialNum: true, // 显示序号
        startImage: '', // 封面图片地址
        endImage: '', // 封底图片地址
        coverImage: '', // 背景图片地址
        qrcodeBgImage: '', // 二维码背景图片地址
        attachment: [], // 适用门店
      },
      form: {
      },
      accessRoles: [], // 可访问角色
      doorInfos: [],
      questionsDialog: false,
      tagOptions: ['RO', 'RT'],
      questions: [],
      initQuestions: [],
      editQuestion: {},
      initQuestion: {
        type: '1',
        maxScore: 10,
        items: [],
        necessary: false,
        optionMin: 1,
        optionMax: '',
        name: _.cloneDeep(multiInputDefault),
        detail: _.cloneDeep(multiInputDefault),
        rightLabel: '',
        leftLabel: ''
      },
      operation: '',
      editIndex: '', // 当前编辑的题目的索引
      editor: null,
      currentContent: ''
    }
  },
  mounted () {
    if (this.id) {
      this.initData()
    } else {
      // setTimeout(() => {this.editorInit()}, 1000)
      this.onReset()
    }
  },
  methods: {
    resetEditor(content) {
      this.editor.txt.html(content);
    },
    editorInit() {
      let that = this;
      this.editor = new Editor(this.$refs.editor);
      this.editor.config.pasteFilterStyle = false;
      this.editor.config.showLinkImg = false;
      this.editor.config.height = 580
      this.editor.config.focus = false;
      this.editor.config.placeholder = '请输入题干';
      this.editor.config.onchange = (html) => {
        this.currentContent = html;
      };
      this.editor.config.excludeMenus = ["video"];
      this.editor.config.customUploadImg = function (files, insert) {
        if (files.length > 1) {
          that.$message.error("每次只能上传1张图片！");
          return;
        }
        const isIMAGE =
          files[0].type === "image/jpeg" ||
          "image/gif" ||
          "image/png" ||
          "image/jpg";
        const isLt800K = files[0].size / 1024 < 2048;
        if (!isIMAGE) {
          that.$message.error("上传图片只支持jpg/jpeg/gif/png格式!");
          return;
        }
        if (!isLt800K) {
          that.$message.error("上传图片大小不能超过 2M!");
          return;
        }
        let formdata = new FormData();
        formdata.append("file", files[0]);
        formdata.append("type", 6);
        window.instance.post(window.pubServer + "/upload/upload", formdata).then((res) => {
          insert(res.data.data.result.imageUrl);
        });
      };
      this.editor.create();
      console.log('this.editor', this.editor)
      this.editor.txt.html(this.currentContent);
    },
    onClose: function () {
      this.$router.push({ path: '/survey' })
    },
    debugQuestions: function () {
      console.log('this.questions', this.questions)
    },
    onReset: function () {
      this.form = _.cloneDeep(this.initForm)
      this.questions = _.cloneDeep(this.initQuestions)
      console.log('this.questions', this.questions)
    },

    initData: async function () {
      let res = await window.instance.post(window.surveyUrl + '/questionnaire/detail', { id: this.id })
      res = res.data
      if (res.code === 200) {
        const result = res.data
        this.initForm.name = result.name
        this.initForm.isEnable = result.isEnable
        this.initForm.remark = result.remark
        this.initForm.image = result.image
        this.getInitQuestions(result.questions)
        this.onReset()
      } else {
        this.$message.warning(res.message)
      }
    },

    // 把获取到的questions转换成页面展示和编辑需要的questions
    getInitQuestions: function (initQuestions) {
      const questions = []
      _.each(initQuestions, (question, index) => {
        if(!question.isGroup) {
          // 正常题目
          let aQ = {}
          aQ.isGroup = false,
          aQ.questionId = question.questionId // 题目id
          aQ.depLogic = question.depend // 依赖的方式
          aQ.index = index + 1 // 题目序号
          aQ.questionIndex = index // 索引
          aQ.computedQuestionIndex = index + 1 // 索引
          aQ.showIndex = index + 1 + '.' // 显示题目序号
          aQ.items = question.items// 题目选项
          aQ.questionName = question.questionObject.name // 题目名称
          aQ.questionType = question.questionObject.type // 题目类型
          aQ.maxScore = question.questionObject.maxScore
          aQ.skips = _.map(question.skips, (skip) => {
            if (skip.type === 4) {
              return skip.questionId
            } else if (skip.type === 1) {
              return ''
            } else if (skip.type === 2 || skip.type === 3) {
              return 'type-' + skip.type
            }
          })
          if (question.questionObject.type === 3) {
            aQ.scopes = _.map(question.skips, (skip) => {
              return {
                from: skip.startScore,
                to: skip.endScore
              }
            })
          }
          questions.push(aQ)
        } else {
          // 题目组
          let aQ = {}
          aQ.questionId = question.questionId // 题目组id
          aQ.index = index + 1 // 题目序号
          aQ.questionIndex = index // 索引
          aQ.computedQuestionIndex = index + 1 // 索引
          aQ.showIndex = index + 1 + '.' // 显示题目序号
          aQ.groupName = question.groupTitle // 题目组名称
          aQ.groupType = question.groupType // 题目组类型
          aQ.isGroup = true
          aQ.groupQuestions = _.map(question.groupQuestions, (innerQuestion, j) => {
            return {
              questionId: innerQuestion.questionId,
              depLogic: innerQuestion.depend, // 依赖的方式
              index: j + 1, // 题目序号
              questionIndex: index + '_' + j, // 索引
              computedQuestionIndex: (index + 1) + '_' + (j + 1),
              showIndex: j + 1 + '.', // 显示题目序号
              items: innerQuestion.items, // 题目选项
              questionName : innerQuestion.questionObject.name, // 题目名称
              questionType : innerQuestion.questionObject.type, // 题目类型
              maxScore : innerQuestion.questionObject.maxScore
            }
          })
          questions.push(aQ)
        }
      })
      _.each(questions, (ques, index) => {
        if (!ques.isGroup) {
          // dep.questionId
          ques.deps = _.map(initQuestions[index].depends, (dep) => {
            let res;
            _.each(questions, (q, index) => {
              if (!q.isGroup) {
                if (q.questionId === dep.questionId) {
                  res = q
                }
              } else if(q.isGroup){
                _.each(q.groupQuestions, (innerQ, index) => {
                  if(dep.questionId === innerQ.questionId){
                    res = innerQ;
                  }
                })
              }

            })

            // return _.find(questions, (question) => {
            //   if(!question.isGroup){
            //     return question.questionId === dep.questionId
            //   } else {
            //
            //   }
            // })
            return res
          }) // 依赖的题目


          ques.depResult = _.map(initQuestions[index].depends, (dep) => {
            return _.map(dep.scoreAreas, (area) => {
              if (area.itemId) {
                return area.itemId
              } else {
                return {
                  from: area.startScore,
                  to: area.endScore,
                  isDep: area.isEnable
                }
              }
            })
          }) // 依赖的选项(分段)
        } else {
          // 给题目组里的题目设置依赖
          _.each(ques.groupQuestions, (innerQues, k) => {
            console.log('innerQues', innerQues)
            innerQues.deps = _.map(initQuestions[index]['groupQuestions'][k].depends, (dep) => {
              return _.find(questions, (question) => {
                return question.questionId === dep.questionId
              })
            }) // 依赖的题目
            innerQues.depResult = _.map(initQuestions[index]['groupQuestions'][k].depends, (dep) => {
              return _.map(dep.scoreAreas, (area) => {
                if (area.itemId) {
                  return area.itemId
                } else {
                  return {
                    from: area.startScore,
                    to: area.endScore,
                    isDep: area.isEnable
                  }
                }
              })
            }) // 依赖的选项(分段)
          })

        }
        console.log('questions依赖', ques)
      })

      this.initQuestions = questions
    },

    onSave: async function () {
      // 提交的格式
      let submitResult = _.cloneDeep(this.form)
      submitResult.type = 1
      let submitQuestions = []
      console.log('this.questions', this.questions)
      _.each(this.questions, (question, i) => {
        const convertedQuestion = this.$refs.EditQuestions.convertOutQuestionToSubmit(question, i)
        submitQuestions.push(convertedQuestion)
      })
      submitResult.questions = submitQuestions
      if (!_.isNil(this.id)) {
        submitResult.id = this.id
      }
      console.log('<=================================submitResult=================================>', submitResult)
      if (!submitResult.name) {
        this.$message.error(this.$t('survey.needName'))
        return false
      }
      await this.submitSurvey(submitResult)
    },

    submitSurvey: async function (submitData) {
      let res = await window.instance.post(window.surveyUrl + '/questionnaire/save', submitData)
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
        this.$router.push({ path: '/survey' })
      } else {
        // todo
      }
    },

    // 跳转tab
    next(activeName) {
      this.activeName = activeName;
    },

    // 添加题目
    addQuestion: function () {
      this.questionsDialog = true
      this.operation = this.$t('new')
      this.editQuestion = _.cloneDeep(this.initQuestion)
      // 题干部分富文本设置
      if (this.editor) {
        // 已经有编辑器,设置内容
        this.currentContent = '';
        this.resetEditor(this.currentContent)
      } else {
        // 没有编辑器,初始化编辑器
        setTimeout(() => {
          this.editorInit()
        }, 100)
      }
    },


    // 编辑题目
    onEditQuestion: function (index) {
      this.questionsDialog = true
      this.operation = this.$t('edit')
      this.editQuestion = _.cloneDeep(this.questions[index])
      this.editIndex = index
      console.log('this.editQuestion', this.editQuestion)
      // 题干部分富文本设置
      if (this.editor) {
        // 已经有编辑器,设置内容
        this.currentContent = this.editQuestion.detail;
        this.resetEditor(this.currentContent)
      } else {
        // 没有编辑器,初始化编辑器
        setTimeout(() => {
          this.editorInit(this.currentContent)
        }, 100)
      }
    },


    // 确定题目(编辑/新增)
    confirmQuestion: function () {
      if(this.operation === this.$t('edit')) {
        this.questions[this.editIndex] = _.cloneDeep(this.editQuestion)
        this.questions[this.editIndex].detail = _.cloneDeep(this.currentContent)
        this.questionsDialog = false
        this.editQuestion = _.cloneDeep(this.initQuestion)
        console.log('this.questions', this.questions)
      }
      else {
        const newQuestion = _.cloneDeep(this.editQuestion)
        newQuestion.detail = _.cloneDeep(this.currentContent)
        this.questions.push(newQuestion)
        this.questionsDialog = false
        this.editQuestion = _.cloneDeep(this.initQuestion)
        console.log('this.questions', this.questions)
      }
    },

    // 添加选项
    addOption: function () {
      this.editQuestion.items.push({
        content: _.cloneDeep(multiInputDefault),
        isInput: false,
        necessary: false
      })
    },

    // 添加其他选项
    addOtherOption: function () {
      this.editQuestion.items.push({
        content: this.$t('other'),
        isInput: true,
        necessary: false
      })
    },

    // 删除问题的选项
    onDeleteItem: function (index) {
      this.editQuestion.items.splice(index, 1)
    },


    // 删除问题
    onDeleteQuestion: function (index) {
      this.$confirm('确认删除该题目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.questions.splice(index, 1)
        })
        .catch(_ => {})
    },

    // 切换题目类型
    changeType: function (ev, type) {
      const prevType = type
      this.$confirm('你确定切换吗？\n' +
        '切换后题目选项将被清空', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.resetQuestion()
        })
        .catch(_ => {
          ev.preventDefault()
          ev.stopPropagation()
          this.editQuestion.type = prevType
        })
    },


    // 计算指定的type值对应的题目类型
    computeType: function (type) {
      let result
      switch (type) {
        case '1':
          result = '单选题'
          break
        case '2':
          result = '多选题'
          break
        case '3':
          result = 'NPS量表题'
          break
        case '4':
          result = '填空题'
          break
        case '5':
          result = '文本说明'
          break
        default:
          result = ''
      }
      return result
    },

    // 重置问题的选项/分值
    resetQuestion: function () {
      this.editQuestion.maxScore = 10
      // this.editQuestion.maxText = ''
      // this.editQuestion.minText = ''
      this.editQuestion.items = []
    },

    // 改变题目顺序
    changeSort(value, index) {
      // value是输入的题目顺序
      // index是输入之前题目原来的顺序
      // 复制一份问题列表
      const copyQuestions = _.cloneDeep(this.questions)
      // 移除需要改顺序的那一题
      const removedQuestion = _.pullAt(copyQuestions, index)[0]
      // 在原来的questions的value位置,插入这道题
      copyQuestions.splice(value - 1, 0, removedQuestion);
      _.each(copyQuestions, (ques, j) => {
        ques.sort = j + 1
      })
      this.questions = _.cloneDeep(copyQuestions)
    }
  }
}
</script>

<style>
.w-e-text-container {
  height: 200px !important;
}
</style>
<style scoped lang="sass">
#editNewSurvey
.checkboxList
  .el-checkbox
    display: block
    margin: 14px 0
    font-weight: 300
  em
    font-style: normal
.customFormItem
  display: flex
  margin-bottom: 20px

.customFormItem .label
  text-align: right
  width: 200px
  vertical-align: middle
  float: left
  font-size: 14px
  color: #606266
  line-height: 36px
  padding: 0 12px 0 0
  -webkit-box-sizing: border-box
  box-sizing: border-box
  flex-shrink: 0

.customFormItemInner .label
  width: 100px

.customFormItem .label em
  font-style: normal
  color: #d82341
  margin-right: 4px

.customFormItem .input-box
  font-size: 12px
  color: #606266

.customFormItem .input-box span
  margin-left: 5px

.customFormItem  .formItemContent
  line-height: 36px
  width: 100%

.scoreText
  ul
    list-style: none
    margin: 0 100px
    padding: 0
    display: flex
    justify-content: space-between
    li
      display: block
      width: 20px
      height: 20px
      border-radius: 100%
      background: #eee
      overflow: hidden
  .scoreTextInput
    padding: 20px 34px 0

.questionsContainer
  .innerQuestionBox
    margin: 20px 0
  .questionBox
    list-style: none
    margin: 0
    padding: 0
    &:nth-last-of-type()
      border-bottom: 0
    li
      list-style: none
      font-size: 14px
      color: #606266
      line-height: 40px
      border-bottom: 1px solid #efefef
      margin-bottom: 20px
      padding-bottom: 20px
      &:last-child
        border-bottom: 0
        margin-bottom: 0
        padding-bottom: 0
      i
        cursor: pointer
        font-size: 16px

      .options
        display: flex
        flex-direction: column
        font-size: 12px
        color: #aaa
        .option
          line-height: 24px



.questionOptionsContainer
  .optionsBox
    list-style: none
    margin: 0
    padding: 0
    &:nth-last-of-type()
      border-bottom: 0
    li
      line-height: 40px
      border-bottom: 1px solid #efefef
      margin-bottom: 20px
      padding: 0
      padding-bottom: 18px
      &:last-child
        border-bottom: 0
        margin-bottom: 0
      i
        cursor: pointer

footer
  padding-top: 20px
  text-align: center
</style>



// WEBPACK FOOTER //
// src/openSurvey/pages/EditNewSurvey多语言备份.vue